<template>
  <div v-if="items.length">
    <template v-for="({ img, link, target }, keyItems) in items">
      <Modal v-if="img" :key="keyItems">
        <a v-if="link" :href="link" :target="target ? '_blank' : '_self'">
          <img :src="files + img" class="d-block" width="100%" />
        </a>

        <img v-else :src="files + img" class="d-block" width="100%" />
      </Modal>
    </template>
  </div>
</template>

<script>
import Modal from "./Modal.vue";

const _config = {
  mod: "popups",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  mounted() {
    this.$rest(_config.mod).get();
  },
  components: {
    Modal,
  },
};
</script>
